import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import Fab from '@material-ui/core/Fab';
import Icon from '@ro-atoms/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import RoBadge from '@ro-atoms/RoBadge';

import { Link } from 'react-router-dom';

import { StyledButton, styles } from './ControlItem.styles';

class ControlItem extends PureComponent {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      selected: props.selected
    };
  }
  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }
  render() {
    const { tooltip, icon, link, iconComponent, classes, iconSize, badge, color } = this.props;

    const Inner = () => {
      return (
        <Tooltip title={tooltip} placement="right" classes={{ tooltip: classes.itemTooltip }}>
          <StyledButton {...this.props}>
            <RoBadge
              direction={badge && badge.direction}
              invert={badge && badge.invert}
              badgeContent={badge && <span>{badge.text}</span>}
              max={99}
              bg={(badge && badge.color) || color}
              asActive={badge && badge.asActive}
            >
              <Fab aria-label="edit" className="tool-item">
                {icon && <Icon name={icon} style={{ fontSize: iconSize }} />}
                {iconComponent}
              </Fab>
            </RoBadge>
          </StyledButton>
        </Tooltip>
      );
    };
    return link ? (
      /^https?:\/\//.test(link) ? (
        <a href={link}>
          <Inner />
        </a>
      ) : (
        <Link to={link}>
          <Inner />
        </Link>
      )
    ) : (
      <Inner />
    );
  }
}

ControlItem.defaultProps = {
  color: ['deepPurple', 400, 600]
};

ControlItem.propTypes = {
  color: propTypes.array
};

export default withStyles(styles)(ControlItem);
